import { oc } from "@orpc/contract";
import { z } from "zod";

const UUIDSchema = z.uuid();

export const UserBasicInfoSchema = z.object({
  id: UUIDSchema,
  name: z.string(),
  email: z.string().nullable().optional(),
});

export const UsersByIdsInputSchema = z.object({
  ids: z.array(UUIDSchema).min(1).max(500),
});

export const UsersByIdsResponseSchema = z.array(UserBasicInfoSchema);

/**
 * Compact org-user listing for picker UIs. Returns every active user in
 * the caller's organization, sorted by name. Caps at 500 — orgs that
 * exceed this need a paginated/searchable variant later.
 */
export const ListUsersInOrgOutputSchema = z.array(UserBasicInfoSchema);

export const usersContracts = {
  byIds: oc
    .input(UsersByIdsInputSchema)
    .output(UsersByIdsResponseSchema)
    .route({ method: "GET" }),

  listInOrg: oc.output(ListUsersInOrgOutputSchema).route({ method: "GET" }),
} as const;

export type UserBasicInfo = z.infer<typeof UserBasicInfoSchema>;
export type UsersByIdsInput = z.infer<typeof UsersByIdsInputSchema>;
export type UsersByIdsResponse = z.infer<typeof UsersByIdsResponseSchema>;
export type ListUsersInOrgOutput = z.infer<typeof ListUsersInOrgOutputSchema>;
